import StudentPracQuizProgress from './StudentPracQuizProgress';

export default StudentPracQuizProgress;
